import { FC } from 'react'
import { AbsoluteDiv } from '../../featureSliced/shared/utils/absoluteDiv'
import { CCProvider } from '../../featureSliced/shared/utils/getCCProviderIcon'
import { CheckBox } from '../CheckBox'

import { CardContainer, CardNumber, BottomCorner } from './styled'
import { RenderIf } from 'components/RenderIf'

type CardProps = {
  cardNumber?: string
  dueDate?: string
  brand?: string
  onCheckBoxClick?: (value: boolean) => void
}

export const Card: FC<CardProps> = ({
  cardNumber,
  dueDate,
  brand,
  onCheckBoxClick,
}) => {
  const handleCheckBoxClick = (value: boolean) => {
    onCheckBoxClick && onCheckBoxClick(value)
  }

  return (
    <CardContainer data-testid="card_test-id">
      <CardNumber>{cardNumber}</CardNumber>
      {/* <AbsoluteDiv top="20px" right="20px">
        <CheckBox
          isChecked={true}
          checkedColor="darkgreen"
          onClick={handleCheckBoxClick}
          data-testid="card_checkbox__test-id"
        />
      </AbsoluteDiv> */}
      <AbsoluteDiv bottom="22px" left="20px">
        <BottomCorner isLeft>
          <CCProvider cardMask={cardNumber} brandName={brand} height={24} />
        </BottomCorner>
      </AbsoluteDiv>
      <RenderIf condition={!!dueDate}>
        <AbsoluteDiv bottom="20px" right="20px">
          <BottomCorner>
            <p>{dueDate}</p>
          </BottomCorner>
        </AbsoluteDiv>
      </RenderIf>
    </CardContainer>
  )
}
